//
import { ModuleLayout } from "@/components/reusable_components/next"

//
import QueryListView from "@/views/General/GQuery/list"
import QueryCreateView from "@/views/General/GQuery/create"
import QueryRunView from "@/views/General/GQuery/run"
import QueryUpdateView from "@/views/General/GQuery/update"

//
export default {
    path: "queries",
    component: ModuleLayout,
    children: [
        {
            name: "query-list",
            path: "",
            component: QueryListView,
        },
        {
            name: "query-create",
            path: "create",
            component: QueryCreateView,
            meta: {
                title: "Crear consulta"
            },
        },
        {
            name: "query-update",
            path: ":id",
            component: QueryUpdateView,
            meta: {
                title: "Detalle de consulta"
            },
        },
        {
            name: "query-run",
            path: ":id/run",
            component: QueryRunView,
            meta: {
                title: "Ejecutar consulta"
            },
        },
    ],
    meta: {
        title: "Consultas"
    },
}